import {getClonedObject} from "@wms/core";
import {get, startsWith, set, camelCase} from "lodash-es";
import {PropertiesPanelComponent} from "./properties-panel.component";
import {runtimeEventManager} from "@wm/core";

let self: PropertyController;

export class PropertyController {
  constructor() {
    self = this;
  }

  resolveValue(name: string, data: {[key: string]: any}) {
    let result = getClonedObject(data);

    if (name === "updateProperty") {
      if (get(result, 'oldValue') === undefined) {
        set(result, 'oldValue', '');
      }
    }
    return result;
  }


  updateProperty(data: {"property": string, "value": any, "oldValue": any}, comp: PropertiesPanelComponent) {
    /*html widget should have its innerHTML set not the text attribute*/
    let tagName,
      el,
      markup;

    let markupManager = comp.markupManager;

    el = markupManager.getActiveMarkupEl();
    el = el && el[0];
    if (el) {
      tagName = el.localName;

      if ((tagName === 'wm-html' && data.property === 'content') || (tagName === 'wm-popover' && data.property === 'inlinecontent')) {
        markup = (data.value || '')
          .replace(/<script/g, '&lt;script ') //<script src.. --> &lt;script
          .replace(/<script>/g, '&lt;script&gt;') // <script> --> &lt;script;&gt;
          .replace(/<\/script>/g, '&lt;/script&gt;'); // </script> --> &lt;/script;&gt;
        el.innerHTML = markup;
      } else {
        // IE11 is failing to convert attr name to lowercase,
        // To fix this, converting manually into lowercase and passing to set attr
        el.setAttribute(data.property.toLowerCase(), data.value);
      }

      //Remove content attribute on change of contentsource to inline for popover widget
      if (tagName === 'wm-popover' && data.property === 'contentsource') {
        if (data.value === 'inline') {
          el.removeAttribute('content');
        }
      }
    }

    // notify the composite parent when ever there is a change in placeholder / default value
    if ((data.property === 'placeholder' || data.property === 'datavalue') && comp.activeWidget.$element) {
      let compositeEl = comp.activeWidget?.$element.closest('.caption-floating');
      if (compositeEl.length === 0) {
        compositeEl = comp.activeWidget.$element.find('.caption-floating');
      }
      if (compositeEl.length) {
        // $rootScope.$emit('on-property-change', compositeEl, data.property, data.value);
      }
    }

    if (startsWith(data.property, 'on-')) {
      self.updateWidgetEvtValue(comp.activeWidget, data.property, data.value);
    }
  }

  updateWidgetEvtValue(activeWidget: any, evtName: string, evtValue: string) {
    let key = '__' + camelCase(evtName);
    activeWidget[key] = evtValue;
  }
  updateLayout(obj: {"property": string, "value": any, "oldValue": any, id?: any}) {
    // this.changeLayout(obj.value, obj.oldValue);
  }

  savePreState(name: string, data: {[key: string]: any}, comp: PropertiesPanelComponent) {
    let result = getClonedObject(data);
    if (name === "updateProperty") {
      set(result, 'id', comp.activeWidget.widgetId);
    }
    return self.resolveValue(name, result);
  }

  savePostState(name: string, data: {"property": string, "value": any, "oldValue": any, id?: any}) {
    return data;
  }

  undo(name: string, data: {"property": string, "value": any, "oldValue": any, id?: any}, comp: PropertiesPanelComponent) {
    switch (name) {
      case 'updateProperty':
        if (comp.activeWidget.widgetId !== data.id) {
          runtimeEventManager.emit('set-active-widget', data.id);
        }
        setTimeout(() => {
          comp.shadowPropertyChange(data.property, data.oldValue, '', 'undo');
        });
        break;
      case 'updateLayout':
        // this.changeLayout(data.oldValue, data.value);
        break;
    }
  }

  redo(name: string, data: {"property": string, "value": any, "oldValue": any, id?: any}, comp: PropertiesPanelComponent) {
    switch (name) {
      case 'updateProperty':
        if (comp.activeWidget.widgetId !== data.id) {
          runtimeEventManager.emit('set-active-widget', data.id);
        }
        setTimeout(() => {
          comp.shadowPropertyChange(data.property, data.value, '', 'redo');
        });
        break;
      case 'updateLayout':
        // this.changeLayout(data.value, data.pageName);
        break;
    }
  }
}
